import { Vendor } from '@/types/resources/vendor';
import dayjs from 'dayjs';

const WORKSPACE_ID = 'demo-workspace';
const createWorkspaceRef = () => ({
  id: WORKSPACE_ID,
  name: 'Jardins do Pôr do Sol',
  slug: 'demo-workspace',
});

const categories = ['Encanamento', 'Elétrica', 'Paisagismo', 'Catering', 'Serviços de Segurança', 'Suporte TI', 'Controle de Pragas', 'Gestão de Resíduos'];
const companyNames = [
  'Soluções Apex', 'Serviços Estelares', 'Inovar Inc.', 'Co. Salto Quântico', 'Grupo Vertex',
  'Provedores Pinnacle', 'Sistemas Sinergia', 'Contratantes Blue-Ribbon', 'Obras Zenith', 'Empresas Fusão',
  'Elétricos Evergreen', 'Encanadores AquaFlow', 'Paisagismo GreenScape', 'Co. Catering Gourmet', 'Segurança Fortaleza',
  'TI TechGenius', 'Controle de Pragas BugBusters', 'Gestão de Resíduos EcoClean', 'Manutenção Pro-Tech', 'Reparos Confiáveis'
];

export const vendors: Vendor[] = Array.from({ length: 50 }, (_, idx) => {
  const companyName = companyNames[idx % companyNames.length];
  const category = categories[idx % categories.length];
  
  return {
    id: `VEND-${(idx + 1).toString().padStart(3, '0')}`,
    type: 'service_provider',
    status: idx % 10 === 0 ? 'inactive' : 'active',
    name: `${companyName} #${idx + 1}`,
    contactPerson: `Pessoa de Contato ${idx + 1}`,
    category: category,
    email: `contact.person.${idx + 1}@${companyName.toLowerCase().replace(/ /g, '')}.com`,
    phone: `+1-555-0200-${idx}`,
    address: `${100 + idx} Parque Empresarial, Suíte 100, Cidade Demo`,
    services: [category],
    paymentTerms: 'net30',
    workspace: createWorkspaceRef(),
    activityRecords: [{
      timestamp: dayjs().subtract(Math.floor(Math.random() * 30), 'days').toDate(),
      type: 'created',
      performedBy: { id: 'admin-001', displayName: 'Gerente de Propriedade' }
    }]
  };
}); 